/**
 * HistoryPanel — placeholder for the History tab.
 *
 * The slot is reserved for a longer history view (score over time, a
 * baseline diff timeline, per-pillar regressions). Until it ships, the tab
 * renders a Carbon tile with the shared empty state so the tab is reachable
 * and the `?tab=history` URL contract works.
 */

import { Tile } from '@/components/carbon'
import EmptyState from '@/components/shared/EmptyState'

export default function HistoryPanel() {
  return (
    <div id="panel-history" role="tabpanel" aria-labelledby="tab-history" className="mt-8">
      <Tile padding={24}>
        <EmptyState
          headline="A longer history of your posture lands here."
          body="Score over time, a baseline change timeline and per-pillar regressions are next. Until then, the Posture tab shows the last 90 days and Operations shows the live tail."
          cta={{ label: 'Open Posture', to: '/dashboard' }}
        />
      </Tile>
    </div>
  )
}
